import { render, staticRenderFns } from "./RadioCudeBoxSw.vue?vue&type=template&id=338d56be&"
import script from "./RadioCudeBoxSw.vue?vue&type=script&lang=js&"
export * from "./RadioCudeBoxSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports